"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDifficultyCards = void 0;
var EDifficultyCards;
(function (EDifficultyCards) {
    EDifficultyCards["EASY"] = "Facile";
    EDifficultyCards["MEDIUM"] = "Interm\u00E9diaire";
    EDifficultyCards["HARD"] = "Difficile";
})(EDifficultyCards || (EDifficultyCards = {}));
exports.EDifficultyCards = EDifficultyCards;
